import { render, staticRenderFns } from "./Annotator.vue?vue&type=template&id=130a1dcc&scoped=true"
import script from "./Annotator.vue?vue&type=script&lang=js"
export * from "./Annotator.vue?vue&type=script&lang=js"
import style0 from "./Annotator.vue?vue&type=style&index=0&id=130a1dcc&prod&scoped=true&lang=css"
import style1 from "./Annotator.vue?vue&type=style&index=1&id=130a1dcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130a1dcc",
  null
  
)

export default component.exports